import { Directive } from '@angular/core';

/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-box-info-content'
})
export class BoxInfoContentDirective {}


/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-box-info-footer'
})
export class BoxInfoFooterDirective {}


/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-box-info-header'
})
export class BoxInfoHeaderDirective {}
